import { takeLatest, ForkEffect } from "redux-saga/effects";
import ActionConstants from "../constants/";
import workerSaga from "./workerSaga";

// ------------------------------------
// Watchers
// ------------------------------------
export default function* adminTransactionWatcher(): Generator<ForkEffect<never>, void, unknown> {
  yield takeLatest(ActionConstants.POST_ADMIN_TRANSACTION_ACTION, workerSaga);
  yield takeLatest(ActionConstants.POST_ADMIN_MERCHANT_ACTION, workerSaga);
  yield takeLatest(ActionConstants.POST_ADMIN_REFUNDS_AND_SETTLEMENT_ACTION, workerSaga);
  yield takeLatest(ActionConstants.ADMIN_DOWNLOAD_LIST_ACTION, workerSaga);
  yield takeLatest(ActionConstants.BULK_DOWNLOAD_LIST_ACTION, workerSaga);
  yield takeLatest(ActionConstants.POST_PLURAL_TRANSACTION_API_ACTION, workerSaga);
  yield takeLatest(ActionConstants.POST_EDGE_TRANSACTION_API_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_ACQUIRERS_ACTION, workerSaga);
  yield takeLatest(ActionConstants.POST_ADMIN_SETTLEMENTS_ACTION, workerSaga);
  yield takeLatest(ActionConstants.POST_ADMIN_REFUNDS_ACTION, workerSaga);
}
